import { render, staticRenderFns } from "./TendencyTag.vue?vue&type=template&id=137c1bd2&"
import script from "./TendencyTag.vue?vue&type=script&lang=js&"
export * from "./TendencyTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports